import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  TextField,
  Typography,
  Hidden,
  Slide,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useState, useContext } from "react";
import uploadFileToBlob, { baseUrl } from "../../../services/AzureStorage";
import { PlayerProfileService } from "../../../services/playerProfile.Service";
import ProfileImage from "../../../sharedComponents/profileImage/profileImage";
import UploadImagePopup from "../../../sharedComponents/uploadImage/uploadImagePopup";
// // import DateAdapter from "@mui/lab/AdapterMoment";
// import DateAdapter from "@mui/lab/AdapterDateFns";
// import DatePicker from "@mui/lab/DatePicker";
// import LocalizationProvider from "@mui/lab/LocalizationProvider";

//Date related importes
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import moment from "moment";
import { AppDataContext } from "../../../common/appContext";

//UPLOAD EXCEL ICONS.
import UploadIcon from "@mui/icons-material/Upload";
import ClearIcon from "@mui/icons-material/Clear";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import UploadFileIcon from "@mui/icons-material/UploadFile";

//UPLOAD EXCEL 3rd PARTY LIBRARIES.
import * as React from "react";
import { v1 as uuidv1 } from "uuid";
import LoadingButton from "@mui/lab/LoadingButton";
import ExcelJs from "exceljs";

//UPLOAD EXCEL SERVICE IMPORTS.
import { uploadGameScoreFileToBlob } from "../../../services/AzureStorage";
import { GameScoreServices } from "../../../services/gameScore.Services";
import { Role } from "../../../helper";

//UPLOAD EXCEL CONFIGURATIONS.
const MAX_SHEET_COLUMN_LENGTH = 4;
const ALLOWED_SHEET_COLUMN_NAMES = [
  "Time (s)",
  "Left (N)",
  "Right (N)",
  "Combined (N)",
];

const useStyles = makeStyles((theme) => ({
  firstSectionTitle: {
    fontWeight: "500",
    color: "#1d428a",
  },
  label: {
    "& .MuiFormControlLabel-label": {
      fontSize: "0.9rem",
      color: "grey",
      whiteSpace: "nowrap",
    },
  },
}));

const today = moment();

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PersonalDetails(props) {
  const { playerID, playerData, user } = props;
  let userAppRoles = user.appRoles || [];

  const classes = useStyles();
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [isPlayerPodDisabled, setPlayerPodDisabled] = useState(true);
  const [openUpload, setOpenUpload] = useState(false);
  const [profilePicture, setProfilePicture] = useState("");
  const [profilePicSrc, setProfilePicSrc] = useState("");
  const { combineYear, selectedEventId, commonEventList } =
    useContext(AppDataContext);
  const [state, setState] = useState({
    playerPosition: "",
    playerCountry: "",
    playerPOD: "",
    playerState: "",
    playerOtherState: "",
    heightInFeet: "",
    heightInInches: "",
    city: "",
    zipCode: "",
    address: "",
    dateOfBirth: null,
    weight: "",
    twitter: "",
    instagram: "",
    positionDropdownData: [],
    countryDropdownData: [],
    stateDropdownData: [],
    podDropdownData: [],
  });
  const [snackBarProps, setSnackBarProps] = useState({
    openSnack: false,
    variant: "error",
    message: "",
  });

  //BULK EXCEL COUNTER MOVEMENTS DATA HOLDER.
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [allowedFileExtensions, setAllowedFileExtensions] = useState([
    "xlsx",
    "xls",
  ]);
  const elementFileRef = React.useRef(null);
  const [sheetNames, setSheetNames] = useState([]);
  const [sheetData, setSheetData] = useState([]);
  const [counterMovementStation, setCounterMovementStation] = useState("");
  const [counterStations, setCounterStations] = useState([]);
  const [displayFileName, setDisplayFileName] = useState(null);
  const [finalFileName, setFinalFileName] = useState(null);
  const [isUploadBtnInProgress, setIsUploadBtnInProgress] = useState(false);
  const [sheetUploadError, setSheetUploadError] = useState({
    error: false,
    errorMsg: "",
  });

  //...Participate data holders.
  const [participationTypeList, setParticipationTypeList] = useState([]);
  const [participate, setParticipate] = useState([]);

  //... Upload Player PHA documents data holders.
  const [openPHAUploadFile, setOpenPHAUploadFile] = useState(false);
  const [isPHAUploadBtnInProgress, setIsPHAUploadBtnInProgress] =
    useState(false);
  const elementPHAFileRef = React.useRef(null);
  const [displayPHAFileName, setDisplayPHAFileName] = useState(null);
  const [finalPHAFileName, setFinalPHAFileName] = useState(null);
  const allowedPHAFileExtensions = ["pdf", "doc", "docx", "json"];

  // const participationTypeList = [
  //   { EventId: combineYear + "09", participationType: "Combine Invite" },
  //   { EventId: combineYear + "21", participationType: "Elite Camp Invite" },
  //   { EventId: combineYear + "22", participationType: "G League Ignite" },
  //   {
  //     EventId: combineYear + "11",
  //     participationType: "Basketball Africa League",
  //   },
  //   {
  //     EventId: combineYear + "23",
  //     participationType: "Portsmouth",
  //   },
  // ];

  useEffect(() => {
    PlayerProfileService.getPlayerCountryList().then((countryResponse) => {
      PlayerProfileService.getPlayerStateList().then((stateResponse) => {
        PlayerProfileService.getPlayerPositions().then((positionResponse) => {
          let positionApiData = [{ positionId: "", positionName: "None" }];
          positionResponse.data.forEach((item) => {
            positionApiData.push({
              positionId: item.childID,
              positionName: item.childName,
            });
          });
          let countryApiData = [{ countryId: "", countryName: "None" }];
          countryResponse.data.forEach((item) => {
            countryApiData.push({
              countryId: item.childID,
              countryName: item.childName,
            });
          });
          let stateApiData = [];
          stateResponse.data.forEach((item) => {
            stateApiData.push({
              stateId: item.childID,
              stateName: item.childName,
            });
          });
          setState((state) => {
            return {
              ...state,
              positionDropdownData: positionApiData,
              countryDropdownData: countryApiData,
              stateDropdownData: stateApiData,
            };
          });
        });
      });
    });
    PlayerProfileService.getPLayerPODDetails().then((playerPODresponse) => {
      let podAPIData = [{ podId: "0", podName: "None" }];
      playerPODresponse.data.forEach((item) => {
        podAPIData.push({
          podId: item.childID,
          podName: item.childName,
        });
      });
      setState((state) => {
        return {
          ...state,
          podDropdownData: podAPIData,
        };
      });
    });

    PlayerProfileService.getCounterMovementsStatisons().then((response) => {
      const { data } = response;
      const newStationData = data.filter((station) =>
        [204, 205].includes(station.childID)
      );
      setCounterStations(newStationData);
    });
  }, []);

  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        playerPosition: playerData.positionId ? playerData.positionId : "",
        playerCountry: playerData.countryId ? playerData.countryId : "",
        playerState: playerData.stateId ? playerData.stateId : "",
        playerOtherState: playerData.state_Other ? playerData.state_Other : "",
        heightInFeet: playerData.heightInFeet ? playerData.heightInFeet : "",
        heightInInches: playerData.heightInInches
          ? playerData.heightInInches
          : "",
        city: playerData.address2 ? playerData.address2 : "",
        address: playerData.address1,
        zipCode: playerData.zip ? playerData.zip : "",
        dateOfBirth: dayjs(playerData.dob),
        weight: playerData.weight ? playerData.weight : "",
        twitter: playerData.twitter ? playerData.twitter : "",
        instagram: playerData.instagram ? playerData.instagram : "",
      };
    });
    const participateApiData = playerData.participate;
    if (participateApiData && participateApiData.length) {
      let participationTypeData = [...participate];
      participateApiData.forEach((item) => {
        participationTypeData.forEach((elem, i) => {
          if (item.eventId === participationTypeList[i]["EventId"]) {
            elem.participationCheckBox = true;
            elem.jersey = item.jersey ?? "";
            elem.podNumber = item.podNumber ? item.podNumber : "";
            elem.podName = item.podName ? item.podName : "";
          }
        });
        setPlayerPodDisabled(false);
        if (participateApiData[0].podNumber) {
          setState((state) => {
            return {
              ...state,
              playerPOD: participateApiData[0].podNumber,
            };
          });
        }
      });
      setParticipate(participationTypeData);
      setProfilePicture(playerData.headshotURL);
      setProfilePicSrc(
        playerData.headshotURL ? baseUrl(playerData.headshotURL) : ""
      );
    }
  }, [playerData, participationTypeList]);

  useEffect(() => {
    if (commonEventList?.length) {
      setParticipationTypeList(
        commonEventList.map(({ eventId, eventName }) => ({
          EventId: eventId,
          participationType: eventName,
        }))
      );
      setParticipate(createInitialParticipateState(commonEventList.length));
    }
  }, [commonEventList]);

  const handleImageUpload = () => {
    setOpenUpload(true);
  };
  const handleClose = () => {
    setOpenUpload(false);
  };

  const changeProfilePhoto = (file) => {
    // console.log(file);
    if (file.size >= 5000000) {
      setSnackBarProps({
        ...snackBarProps,
        openSnack: true,
        variant: "error",
        message: "Image File is too big",
      });
    } else {
      (async () => {
        if (file) {
          try {
            const picUploaded = await uploadFileToBlob(file);
            if (picUploaded) {
              setProfilePicSrc(URL.createObjectURL(file));
              setProfilePicture(file.name);
              let formObj = {
                playerID: playerID,
                headshotURL: file.name,
                userBy: user.loginID,
              };
              PlayerProfileService.updateProfileImageName(formObj).then(
                (result) => {
                  setAlert(true);
                  setAlertType("success");
                  setAlertMessage("Profile image updated successfully");
                }
              );
            }
          } catch (e) {
            console.log("error", e);
          }
        }
      })();
      handleClose();
    }
  };

  const handleAlertClose = (e) => {
    setAlert(false);
  };

  const handleCountryChange = (value) => {
    setState({ ...state, playerCountry: value, playerState: "" });
  };

  const handleInputChange = (e, key) => {
    if (
      key === "combineInviteJersey" ||
      key === "eliteCampInviteJersey" ||
      key === "gLeagueInviteJersey" ||
      key === "heightInFeet" ||
      key === "heightInInches" ||
      key === "weight"
    ) {
      if (e.target.value.length === 1 && e.target.value === "0") {
        e.preventDefault();
      }
    }

    if (key === "heightInInches") {
      if (parseInt(e.target.value) > 11.99) {
        e.preventDefault();
        return false;
      }
    }

    let finalValue = e.target.value;
    if (
      key === "combineInviteJersey" ||
      key === "eliteCampInviteJersey" ||
      key === "gLeagueInviteJersey" ||
      key === "heightInFeet"
    ) {
      finalValue = e.target.value.replace(/\D/g, "");
    } else if (key === "heightInInches" || key === "weight") {
      finalValue = e.target.value.replace(
        /[a-zA-Z`()\-~!@#$%^&*_=-><?/:;"'{}|\\[\]]/g,
        ""
      );
    } else if (key === "playerPOD") {
      let newData = [...participate];
      newData.forEach((elem) => {
        elem.podNumber = e.target.value;
      });
      setParticipate(newData);
    }

    setState((state) => {
      return { ...state, [key]: finalValue };
    });
  };

  const handleParticipationTypeChange = (e, index, key) => {
    let finalValue = e.target.value;
    let newData = [...participate];
    if (key.includes("jersey")) {
      if (e.target.value.length === 1 && e.target.value === "0") {
        e.preventDefault();
      }
      finalValue = e.target.value.replace(/\D/g, "");
    } else if (key.includes("participationCheckBox")) {
      finalValue = e.target.checked;
      if (!finalValue) {
        newData[index].podNumber = "";
        newData[index].podName = "";
        newData[index].jersey = "";
        newData[index].mode = "delete";
        setParticipate(newData);
        if (
          newData.filter(
            (elem, i) =>
              i !== index && newData[i].participationCheckBox === false
          ).length === 2
        ) {
          setPlayerPodDisabled(true);
          setState((state) => {
            return { ...state, playerPOD: "" };
          });
        }
      } else {
        newData[index].mode = "";
        setPlayerPodDisabled(false);
      }
    }
    newData[index][key] = finalValue;
    setParticipate(newData);
  };

  const handleDateOfBirthChange = (newValue) => {
    setState({ ...state, dateOfBirth: newValue });
  };

  const validateParticipationType = () => {
    return participate.filter((elem) => elem.participationCheckBox).length
      ? true
      : false;
  };

  const submitPlayerDetails = () => {
    const formObj = {
      playerID: playerID,
      playerName: playerData.playerName,
      collegeOrClub: playerData.collegeOrClub,
      headshotURL: profilePicture,
      countryId: state.playerCountry ? state.playerCountry : 0,
      stateId: state.playerState ? state.playerState : 0,
      state_Other: state.playerOtherState,
      address1: state.address,
      address2: state.city,
      address3: "",
      address4: "",
      zip: state.zipCode,
      // dob: state.dateOfBirth,
      // dob: state.dateOfBirth
      //   ? moment.utc(state.dateOfBirth.toLocaleString()).format("YYYY-MM-DD")
      //   : null,
      dob: state.dateOfBirth
        ? dayjs(state.dateOfBirth).format("YYYY-MM-DD")
        : null,
      heightInFeet: state.heightInFeet ? parseInt(state.heightInFeet) : 0,
      heightInInches: state.heightInInches
        ? parseFloat(state.heightInInches)
        : 0,
      weight: state.weight ? parseFloat(state.weight) : 0,
      positionId: state.playerPosition ? state.playerPosition : 0,
      twitter: state.twitter,
      instagram: state.instagram,
      userBy: user.loginID,
    };
    formObj["participate"] = [];

    participate.forEach((elem, i) => {
      if (elem.participationCheckBox || elem.mode === "delete") {
        formObj["participate"].push({
          id: 0,
          userBy: user.loginID,
          mode: elem.mode,
          playerID: playerID,
          EventId: participationTypeList[i]["EventId"],
          jersey: parseInt(elem.jersey ?? 0),
          podNumber:
            elem.mode === "delete"
              ? 0
              : elem.podNumber
              ? parseInt(elem.podNumber)
              : state.playerPOD === ""
              ? 0
              : state.playerPOD,
          podName:
            elem.mode === "delete"
              ? ""
              : elem.podName
              ? elem.podName
              : state.playerPOD === ""
              ? `Pod 0`
              : `Pod ${state.playerPOD}`,
        });
      }
    });

    // return;
    PlayerProfileService.insertUpdatePlayerProfileDetails(formObj).then(
      (result) => {
        setAlert(true);
        setAlertType("success");
        setAlertMessage("Personal Details updated successfully");
      }
    );
  };

  const handleClickOpen = () => {
    setOpenUploadFile(true);
  };

  const handleUploadClose = () => {
    clearFileInput();
    setCounterMovementStation("");
    setSheetUploadError({
      error: false,
      errorMsg: "",
    });
    setOpenUploadFile(false);
  };

  const validateSheetData = (sheetCols, sheetData) => {
    //ADDED CHECK FOR SHEET COLUMN LENGTH
    if (sheetCols.length !== MAX_SHEET_COLUMN_LENGTH) {
      setSheetUploadError({
        error: true,
        errorMsg: `The Sheet columns should be ${MAX_SHEET_COLUMN_LENGTH}.`,
      });
      return false;
    }

    //ADDED CHECK FOR SHEET COLUMN NAMES.
    if (!sheetCols.every((name) => ALLOWED_SHEET_COLUMN_NAMES.includes(name))) {
      setSheetUploadError({
        error: true,
        errorMsg: `The Sheet column names should be 'Time (s)', 'Left (N)','Right (N)', and 'Combined (N)' only.`,
      });
      return false;
    }

    //ADDED CHECK FOR SHEET DATA.
    if (sheetData.length === 0) {
      setSheetUploadError({
        error: true,
        errorMsg: `The sheet cannot be empty..`,
      });
      return false;
    }

    return true;
  };

  const formatJsonData = (headers, values) => {
    return values.map((row) => {
      return headers.reduce((obj, header, index) => {
        obj[header] = row[index];
        return obj;
      }, {});
    });
  };

  const uploadDocumentChangeHandler = async (e) => {
    //console.log(e);
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      let blob = file.slice(0, file.size, file.type);
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);

      //#Extention Validation
      if (!allowedFileExtensions.includes(extension.toLowerCase())) {
        setAlert(true);
        setAlertType("warning");
        setAlertMessage(
          `Please select files with one of ${allowedFileExtensions.join(
            ", "
          )} formats.`
        );
        clearFileInput();
        return;
      }

      //Read Excel Sheet data.
      await readExcelFile(file);

      //Set Display filename.
      setDisplayFileName(file.name.replace(`.${extension}`, ""));

      //Set new filename.
      let newFileName = uuidv1() + "." + extension;

      const newFile = new File([blob], newFileName, { type: file.type });
      setFinalFileName(newFile);
    }
  };

  const readExcelFile = async (file) => {
    const workbook = new ExcelJs.Workbook();
    await workbook.xlsx.load(file);

    var mySheetData = [];
    workbook.eachSheet((worksheet, sheetId) => {
      const iAttemptID = sheetId;
      const rowsData = [];

      worksheet.eachRow((row, rowNumber) => {
        const rowData = [];
        row.eachCell((cell, colNumber) => {
          rowData.push(cell.value);
        });
        rowsData.push(rowData);
      });

      const sheetRawColumns = rowsData[0];
      const jsonData = rowsData.slice(1);

      //VALIDATE SHEET
      const status = validateSheetData(sheetRawColumns, jsonData);

      //GET PRE formatted JSON DATA
      const preFormatedData = formatJsonData(sheetRawColumns, jsonData);

      //PREPARE JSON OBJECT IF DATA VALIDATAED SUCCESSFULY.
      if (status) {
        const newJsonData = preFormatedData.map((data) => ({
          left: "" + data["Left (N)"],
          right: "" + data["Right (N)"],
          combined: "" + data["Combined (N)"],
          time: "" + data["Time (s)"],
          eventId: parseInt(selectedEventId),
          stationId: parseInt(counterMovementStation),
          playerID: parseInt(playerID),
          attempt: iAttemptID,
          userBy: user.loginID,
          createdDate: new Date(),
        }));
        mySheetData.push(...newJsonData);
      }
    });

    //console.log(`mySheetData`, mySheetData);

    //Assign data from sheet to object
    setSheetData(mySheetData);
  };

  const handleStationChange = (event) => {
    setCounterMovementStation(event.target.value);
  };

  const clearFileInput = () => {
    elementFileRef.current.value = null;
    setFinalFileName(null);
    setDisplayFileName(null);
    setSheetUploadError({
      error: false,
      errorMsg: "",
    });
  };

  const toggleAlert = (value, type, message) => {
    setAlert(value);
    setAlertType(type);
    setAlertMessage(message);
  };

  const handleUploadCounterData = async () => {
    if (!counterMovementStation) {
      toggleAlert(true, "warning", "Please choose station for upload.");
      return;
    }

    if (!finalFileName) {
      toggleAlert(true, "warning", "Please choose file for upload.");
      return;
    }

    if (sheetData.length === 0) {
      toggleAlert(true, "error", "Error while reading the sheet data.");
      return;
    }

    setIsUploadBtnInProgress(true);

    try {
      const isBlobUploaded = await uploadGameScoreFileToBlob(finalFileName);

      if (isBlobUploaded) {
        const { data: iDocumentUploadRes } =
          await GameScoreServices.uploadGameScoreDocument({
            docId: 0,
            eventId: selectedEventId,
            docType: "CounterMovements",
            fileExtension: finalFileName.name.substring(
              finalFileName.name.lastIndexOf(".") + 1
            ),
            documentName: finalFileName.name,
            displayName: displayFileName,
            isDeleted: false,
            isPublished: false,
            userBy: user.loginID,
            mode: "",
          });

        if (iDocumentUploadRes > 0) {
          const newArray = sheetData.map((obj) => {
            return {
              ...obj,
              docId: iDocumentUploadRes,
              documentName: "",
            };
          });
          await GameScoreServices.insertCounterMovements(newArray);

          toggleAlert(true, "success", "Details added successfully....");
          setIsUploadBtnInProgress(false);
          handleUploadClose();
        }
      }
    } catch (error) {
      setIsUploadBtnInProgress(false);
      toggleAlert(true, "error", "Something went wrong while uploading file.");
      console.log("error", error);
    }
  };

  const createInitialParticipateState = (length) =>
    Array.from({ length }, () => ({
      participationCheckBox: false,
      jersey: "",
      mode: "",
      podNumber: "",
      podName: "",
    }));

  // PLAYER PHA UPLOAD DOCUMENT UTILITIES
  const handlePHAUploadOpen = () => {
    setOpenPHAUploadFile(true);
  };

  const handlePHAUploadClose = () => {
    clearPHAFileInput();
    setOpenPHAUploadFile(false);
  };

  const uploadPHADocumentChangeHandler = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      let blob = file.slice(0, file.size, file.type);
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);

      //#Extention Validation
      if (!allowedPHAFileExtensions.includes(extension.toLowerCase())) {
        setAlert(true);
        setAlertType("warning");
        setAlertMessage(
          `Please select files with one of ${allowedPHAFileExtensions.join(
            ", "
          )} formats.`
        );
        clearFileInput();
        return;
      }
      //#Set Display filename.
      setDisplayPHAFileName(file.name.replace(`.${extension}`, ""));

      //#Set new filename.
      let newFileName = uuidv1() + "." + extension;

      const newFile = new File([blob], newFileName, { type: file.type });
      setFinalPHAFileName(newFile);
    }
  };

  const clearPHAFileInput = () => {
    elementPHAFileRef.current.value = null;
    setFinalFileName(null);
    setFinalPHAFileName(null);
  };

  const handleUploadPlayerPHAData = async () => {
    if (!finalPHAFileName) {
      toggleAlert(true, "warning", "Please choose a file for upload.");
      return;
    }

    setIsPHAUploadBtnInProgress(true);
    try {
      const PHADetails = createPHADetailsFormData();
      await GameScoreServices.savePlayerDexaBodyFatDocuments(PHADetails);

      toggleAlert(true, "success", "Document uploaded successfully.");
      clearPHAFileInput();
      handlePHAUploadClose();
    } catch (error) {
      //console.log("error", error);
      toggleAlert(
        true,
        "error",
        "Something went wrong while uploading the file."
      );
    } finally {
      setIsPHAUploadBtnInProgress(false);
    }
  };

  const createPHADetailsFormData = () => {
    const PHADetails = new FormData();
    PHADetails.append("docId", 0);
    PHADetails.append("EventId", selectedEventId);
    PHADetails.append("DocType", "DexaBodyFat");
    PHADetails.append(
      "FileExtension",
      finalPHAFileName.name.substring(
        finalPHAFileName.name.lastIndexOf(".") + 1
      )
    );
    PHADetails.append("DocumentName", null);
    PHADetails.append("DisplayName", displayPHAFileName);
    PHADetails.append("IsDeleted", false);
    PHADetails.append("IsPublished", false);
    PHADetails.append("CreatedDate", new Date());
    PHADetails.append("UserBy", user.loginID);
    PHADetails.append("Mode", "");
    PHADetails.append("StationId", 108);
    PHADetails.append("PlayerID", parseInt(playerID));
    PHADetails.append("media", finalPHAFileName);
    return PHADetails;
  };

  return (
    <>
      <Paper elevation={5}>
        <Grid container pl={2} pt={1} pb={1.3} pr={2} spacing={3}>
          <Grid item lg={3.3} md={5.5} sm={12} xs={12}>
            <Box>
              <Typography
                noWrap
                variant="subtitle1"
                className={classes.firstSectionTitle}
              >
                Personal Details
              </Typography>
            </Box>
            <Grid container pt={1} spacing={2}>
              <Grid item lg={4.8} md={4.3} sm={4} xs={12}>
                <Box display="flex" flexDirection="row" columnGap={2}>
                  <ProfileImage
                    handleClick={handleImageUpload}
                    src={profilePicSrc}
                  />
                  <Hidden smUp>
                    <Typography
                      variant="h6"
                      sx={{ color: "#1d428a", alignSelf: "center" }}
                    >
                      {playerData.playerName}
                    </Typography>
                  </Hidden>
                </Box>
              </Grid>
              <Grid
                item
                lg={7}
                md={7.5}
                sm={7.5}
                xs={12}
                sx={{ marginTop: "-2px" }}
              >
                <Grid container spacing={2} sx={{ display: "flex" }}>
                  <Grid item lg={8} md={8} sm={8} xs={8}>
                    <Typography
                      noWrap
                      variant="body2"
                      sx={{ color: "#8B8B8B" }}
                    >
                      Participation Type
                    </Typography>
                  </Grid>
                  <Grid item lg={4} md={4} sm={4} xs={4}>
                    <Typography
                      noWrap
                      variant="body2"
                      sx={{ color: "#8B8B8B" }}
                    >
                      Jersey #
                    </Typography>
                  </Grid>
                </Grid>
                {participate?.map((elem, i) => {
                  return (
                    <Grid key={`pp_${i}`} container spacing={2}>
                      <Grid item lg={8} md={8} sm={8} xs={8}>
                        <FormControl size="small" fullWidth margin="dense">
                          <FormControlLabel
                            value="end"
                            control={
                              <Checkbox
                                size="medium"
                                color="success"
                                checked={elem.participationCheckBox}
                                onChange={(e) =>
                                  handleParticipationTypeChange(
                                    e,
                                    i,
                                    "participationCheckBox"
                                  )
                                }
                              />
                            }
                            label={
                              participationTypeList[i]?.participationType || ""
                            }
                            labelPlacement="end"
                            className={classes.label}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item lg={4} md={4} sm={4} xs={4}>
                        <FormControl size="small" fullWidth margin="dense">
                          <TextField
                            size="small"
                            value={elem.jersey}
                            disabled={!elem.participationCheckBox}
                            onChange={(e) =>
                              handleParticipationTypeChange(e, i, "jersey")
                            }
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={4.9} md={6.5} sm={12} xs={12}>
            <Box>
              <Typography
                noWrap
                variant="subtitle1"
                className={classes.firstSectionTitle}
              >
                Residence
              </Typography>
            </Box>
            <Grid
              container
              wrap="nowrap"
              spacing={1}
              // columns={3}
              sx={{ paddingTop: "27px" }}
            >
              <Grid item lg={4} md={4} sm={4} xs={4}>
                <FormControl
                  size="small"
                  fullWidth
                  margin="dense"
                  // sx={{ maxWidth: "180px !important" }}
                >
                  <InputLabel>Country</InputLabel>
                  <Select
                    size="small"
                    label="Country"
                    value={state.playerCountry}
                    onChange={(e) => {
                      handleCountryChange(e.target.value);
                    }}
                  >
                    {state.countryDropdownData.map((elem, i) => {
                      return (
                        <MenuItem key={i} value={elem.countryId}>
                          <span title={elem.countryName}>
                            {elem.countryName}
                          </span>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item lg={4} md={4} sm={4} xs={4} pl={2}>
                {state.playerCountry === 1 ? (
                  <FormControl
                    size="small"
                    fullWidth
                    margin="dense"
                    // sx={{ maxWidth: "160px !important" }}
                  >
                    <InputLabel>State/Province</InputLabel>
                    <Select
                      size="small"
                      label="State/Province"
                      value={state.playerState}
                      onChange={(e) => {
                        handleInputChange(e, "playerState");
                      }}
                    >
                      {state.stateDropdownData.map((elem, i) => {
                        return (
                          <MenuItem key={i} value={elem.stateId}>
                            <span title={elem.stateName}>{elem.stateName}</span>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                ) : (
                  <FormControl size="small" fullWidth margin="dense">
                    <TextField
                      size="small"
                      label="State/Province"
                      value={state.playerOtherState}
                      onChange={(e) => {
                        handleInputChange(e, "playerOtherState");
                      }}
                    />
                  </FormControl>
                )}
              </Grid>
              <Grid item lg={4} md={4} sm={4} xs={4} pl={2}>
                <FormControl size="small" fullWidth margin="dense">
                  <TextField
                    size="small"
                    label="City"
                    value={state.city}
                    onChange={(e) => {
                      handleInputChange(e, "city");
                    }}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item lg={9.5} md={12} sm={12} xs={12}>
                <FormControl size="small" fullWidth margin="dense">
                  <TextField
                    size="small"
                    label="Address"
                    value={state.address}
                    onChange={(e) => {
                      handleInputChange(e, "address");
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item lg={2.5} md={12} sm={12} xs={12}>
                <FormControl size="small" fullWidth margin="dense">
                  <TextField
                    size="small"
                    label="Zip Code"
                    value={state.zipCode}
                    onChange={(e) => {
                      handleInputChange(e, "zipCode");
                    }}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={1.5} mt={0.3}>
              <Grid item lg={7} md={12} sm={12} xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    columnGap: "10px",
                  }}
                >
                  <Typography
                    noWrap
                    variant="subtitle1"
                    className={classes.firstSectionTitle}
                    sx={{ width: "60%", marginTop: "5px" }}
                  >
                    Date of Birth
                  </Typography>
                  <FormControl size="small" fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        clearable
                        disableFuture
                        openTo="year"
                        views={["year", "month", "day"]}
                        disableHighlightToday
                        label="Date of Birth"
                        value={state.dateOfBirth}
                        onChange={handleDateOfBirthChange}
                        slotProps={{ textField: { size: "small" } }}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Box>
              </Grid>
              <Grid item lg={5} md={12} sm={12} xs={12}>
                <FormControl
                  size="small"
                  fullWidth
                  // sx={{ maxWidth: "160px !important" }}
                >
                  <InputLabel>Player POD</InputLabel>
                  <Select
                    size="small"
                    label="Player POD"
                    disabled={isPlayerPodDisabled}
                    value={state.playerPOD}
                    onChange={(e) => {
                      handleInputChange(e, "playerPOD");
                    }}
                  >
                    {state.podDropdownData.map((elem, i) => {
                      return (
                        <MenuItem key={i} value={elem.podId}>
                          <span title={elem.podName}>{elem.podName}</span>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={1.5} mt={0.3}>
              {/* COUNTER MOVEMNT SECTION */}
              <Grid item xs={5}>
                <Box
                  sx={{
                    display: "flex",
                    columnGap: "10px",
                  }}
                >
                  <Typography
                    noWrap
                    variant="subtitle1"
                    className={classes.firstSectionTitle}
                  >
                    Upload Counter Movements
                  </Typography>
                  <Button
                    sx={{
                      textTransform: "none",
                      padding: "2px 2px",
                      marginRight: "5px",
                      cursor: "pointer",
                      minWidth: "20px !important",
                    }}
                    size="small"
                    variant="contained"
                    title="Upload"
                    onClick={handleClickOpen}
                  >
                    <UploadIcon />
                  </Button>
                </Box>
              </Grid>

              {/* DEXABODY FAT DOC UPLOAD SECTION */}
              {userAppRoles.includes(Role.Admin) && (
                <Grid item xs={5}>
                  <Box
                    sx={{
                      display: "flex",
                      columnGap: "10px",
                    }}
                  >
                    <Typography
                      noWrap
                      variant="subtitle1"
                      className={classes.firstSectionTitle}
                    >
                      Upload PHI Documents
                    </Typography>
                    <Button
                      sx={{
                        textTransform: "none",
                        padding: "2px 2px",
                        marginRight: "5px",
                        cursor: "pointer",
                        minWidth: "20px !important",
                      }}
                      size="small"
                      variant="contained"
                      title="Upload"
                      onClick={handlePHAUploadOpen}
                    >
                      <UploadFileIcon />
                    </Button>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid item lg={2.3} md={12} sm={12} xs={12}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Typography
                noWrap
                variant="subtitle1"
                className={classes.firstSectionTitle}
              >
                Basic Anthro
              </Typography>
            </Grid>
            <Grid
              container
              spacing={1}
              sx={{ paddingTop: "27px", justifyContent: "space-between" }}
            >
              <Grid item lg={6} md={6} xs={6} sm={6}>
                <FormControl size="small" fullWidth margin="dense">
                  <TextField
                    size="small"
                    label="Height Feet"
                    value={state.heightInFeet}
                    onChange={(e) => handleInputChange(e, "heightInFeet")}
                  />
                </FormControl>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={6}>
                <FormControl size="small" fullWidth margin="dense">
                  <TextField
                    size="small"
                    label="Height Inches"
                    value={state.heightInInches}
                    onChange={(e) => handleInputChange(e, "heightInInches")}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item lg={6} md={6} sm={6} xs={6}>
                <FormControl size="small" fullWidth margin="dense">
                  <TextField
                    size="small"
                    label="Weight"
                    value={state.weight}
                    onChange={(e) => handleInputChange(e, "weight")}
                  />
                </FormControl>
              </Grid>
              <Grid item lg={6} md={6} sm={6} xs={6}>
                <FormControl size="small" fullWidth margin="dense">
                  <InputLabel>Position</InputLabel>
                  <Select
                    label="Position"
                    value={state.playerPosition}
                    onChange={(e) => {
                      handleInputChange(e, "playerPosition");
                    }}
                  >
                    {state.positionDropdownData.map((elem, i) => {
                      return (
                        <MenuItem key={i} value={elem.positionId}>
                          {elem.positionName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={1.5} md={6} sm={6} xs={12}>
            <Typography
              noWrap
              variant="subtitle1"
              className={classes.firstSectionTitle}
            >
              Social Media
            </Typography>
            <Grid container sx={{ paddingTop: "27px" }}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <FormControl size="small" fullWidth margin="dense">
                  <TextField
                    size="small"
                    label="Twitter"
                    value={state.twitter}
                    onChange={(e) => handleInputChange(e, "twitter")}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container sx={{ textAlign: "right" }}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <FormControl size="small" fullWidth margin="dense">
                  <TextField
                    size="small"
                    label="Instagram"
                    value={state.instagram}
                    onChange={(e) => handleInputChange(e, "instagram")}
                  />
                </FormControl>
              </Grid>
              <Grid item lg={12} pt={2.8}>
                {/* <Button
                  sx={{
                    textTransform: "none",
                    padding: "2px 2px",
                    minWidth: "20px !important",
                    marginRight: "5px",
                  }}
                  size="small"
                  variant="contained"
                  title="Upload"
                  onClick={handleClickOpen}
                >
                  <UploadIcon />
                </Button> */}
                <Button
                  sx={{
                    textTransform: "none",
                    padding: "2px 2px",
                    minWidth: "20px !important",
                  }}
                  size="small"
                  variant="contained"
                  title="Save"
                  disabled={
                    validateParticipationType() ||
                    state.playerCountry ||
                    state.playerState ||
                    state.playerOtherState ||
                    state.city ||
                    state.address ||
                    state.zipCode ||
                    state.heightInFeet ||
                    state.heightInInches ||
                    state.weight ||
                    state.playerPosition ||
                    state.twitter ||
                    state.instagram
                      ? false
                      : true
                  }
                  onClick={submitPlayerDetails}
                >
                  <SaveOutlinedIcon />
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Snackbar
            open={alert}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            autoHideDuration={2000}
            onClose={handleAlertClose}
          >
            <Alert
              onClose={handleAlertClose}
              severity={alertType}
              sx={{ width: "100%" }}
            >
              {alertMessage}
            </Alert>
          </Snackbar>
        </Grid>
      </Paper>
      {openUpload && (
        <UploadImagePopup
          open={openUpload}
          title="Upload Image"
          handleClose={handleClose}
          changeProfilePhoto={changeProfilePhoto}
        />
      )}

      <Dialog
        open={openUploadFile}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleUploadClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth="true"
      >
        <DialogTitle>
          <Stack direction="row" alignItems="center" gap={0.5} sx={{ my: 0.2 }}>
            <CloudUploadIcon />
            <Typography variant="h6">Upload File</Typography>
          </Stack>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Stack spacing={2}>
            {sheetUploadError && sheetUploadError.error ? (
              <Alert severity="error">{sheetUploadError.errorMsg}</Alert>
            ) : (
              <Alert severity="info">Bulk upload for counter movements!</Alert>
            )}
            <FormControl size="small" fullWidth>
              <InputLabel id="idStationInputLable">Station</InputLabel>
              <Select
                labelId="idStationLabelID"
                id="idStationSelect"
                value={counterMovementStation}
                label="Station"
                onChange={handleStationChange}
                sx={{
                  "& #idStationSelect": {
                    fontSize: "0.9rem",
                  },
                }}
              >
                {counterStations?.map((elem, i) => {
                  return (
                    <MenuItem
                      key={i}
                      value={elem.childID}
                      sx={{ fontSize: "1rem" }}
                    >
                      {elem.childName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <Paper elevation={2} sx={{ p: "10px" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <input
                  type="file"
                  accept=".xlsx,.xls"
                  ref={elementFileRef}
                  onChange={uploadDocumentChangeHandler}
                  className={classes.fileInput}
                />

                {finalFileName && <ClearIcon onClick={clearFileInput} />}
              </Box>
            </Paper>
          </Stack>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              component="label"
              onClick={handleUploadClose}
              size="small"
              color="error"
            >
              Cancel
            </Button>

            {isUploadBtnInProgress ? (
              <LoadingButton
                loading
                loadingPosition="start"
                startIcon={<UploadIcon />}
                variant="contained"
              >
                Upload
              </LoadingButton>
            ) : (
              <Button
                variant="contained"
                component="label"
                onClick={handleUploadCounterData}
                size="small"
                disabled={sheetUploadError.error}
              >
                Upload
              </Button>
            )}
          </Stack>
        </DialogActions>
      </Dialog>

      {/* Upload Player PHA document Dialog Box */}
      <Dialog
        open={openPHAUploadFile}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleUploadClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth="true"
      >
        <DialogTitle>
          <Stack direction="row" alignItems="center" gap={0.5} sx={{ my: 0.2 }}>
            <CloudUploadIcon />
            <Typography variant="h6">Upload File</Typography>
          </Stack>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Stack spacing={2}>
            <Paper elevation={2} sx={{ p: "10px" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <input
                  type="file"
                  // accept=".xlsx,.xls"
                  ref={elementPHAFileRef}
                  onChange={uploadPHADocumentChangeHandler}
                  className={classes.fileInput}
                />

                {finalPHAFileName && <ClearIcon onClick={clearPHAFileInput} />}
              </Box>
            </Paper>
          </Stack>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              component="label"
              onClick={handlePHAUploadClose}
              size="small"
              color="error"
            >
              Cancel
            </Button>

            {isPHAUploadBtnInProgress ? (
              <LoadingButton
                loading
                loadingPosition="start"
                startIcon={<UploadIcon />}
                variant="contained"
              >
                Upload
              </LoadingButton>
            ) : (
              <Button
                variant="contained"
                component="label"
                onClick={handleUploadPlayerPHAData}
                size="small"
              >
                Upload
              </Button>
            )}
          </Stack>
        </DialogActions>
      </Dialog>
    </>
  );
}
